module.exports = __webpack_public_path__ + "media/images/balance-product-bottle-4ce4d37137b0c258a7ec18e39205202d.png";